import http from '../api'

// import Paginator from '../_paginator';


let saveAvaliation = (data) => {
    return http.post('save-rating', data)
}

 let getAllData = (data) => {
    return http.get(`get-rating/?company_id=${data}` )
    // return http.get(`indications/${data}`)

}
export default {
    saveAvaliation,
    getAllData
}